export const offices: string[] = [
	"AU", "BR", "CA", "CH", "DE", "EM", "ES", "FR", "GB", "IN", "IT", "JP", "KR", "MX", "MY", "NZ", "SG", "US", "WO"
]